<template>
  <div>
    <section aria-labelledby="history-title">
      <Card>
        <div class="divide-y divide-gray-200">
          <CardHeader>
            <CardTitle> History </CardTitle>
          </CardHeader>
          <CardContent>
            <ZeroState v-if="history.length === 0" class="mt-4">No advertising history yet.</ZeroState>
            <DataTable v-else :columns="columns" :rows="history" />
          </CardContent>
        </div>
      </Card>
    </section>
  </div>
</template>

<script setup lang="ts">
import DataTable from '../../../shared/DataTable/DeprecatedDataTable.vue';
import ZeroState from '@/components/ZeroState.vue';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { formatCurrencyToHuman, formatStandardDate } from '../../../../utilities/format.ts';

export type AdvertisingHistoryRow = {
  start_date: string | null;
  end_date: string | null;
  indeed_spend: number;
  zip_spend: number;
  monster_spend: number;
  meta_spend: number;
  total_spend: number;
};

defineProps<{ history: AdvertisingHistoryRow[] }>();

const columns = [
  { label: 'Start Date', key: 'start_date', sortable: false, formatter: formatStandardDate },
  { label: 'End Date', key: 'end_date', sortable: false, formatter: formatStandardDate },
  { label: 'Indeed', key: 'indeed_spend', sortable: false, formatter: formatCurrencyToHuman },
  { label: 'ZipRecruiter', key: 'zip_spend', sortable: false, formatter: formatCurrencyToHuman },
  { label: 'Monster', key: 'monster_spend', sortable: false, formatter: formatCurrencyToHuman },
  { label: 'Meta', key: 'meta_spend', sortable: false, formatter: formatCurrencyToHuman },
  { label: 'Total Spend', key: 'total_spend', sortable: false, formatter: formatCurrencyToHuman },
];
</script>
